import { notify } from 'reducers/NotifierReducer';

// Clear loading before executing callbacks.
// Success handlers may close the dialog and unmount the component.
// Calling setLoading(false) after unmount causes:
// "Can't perform a React state update on an unmounted component".
export const executeApiAction = async ({
  action,
  onSuccess,
  onError,
  onFinally,
  setLoading,
  dispatch,
}) => {
  try {
    setLoading?.(true);
    const result = await action();
    setLoading?.(false);
    onSuccess?.(result);
    return result;
  } catch (error) {
    console.error(error);
    setLoading?.(false);
    onError?.(error);
    dispatch?.(notify(error.message, 'error'));
  } finally {
    onFinally?.();
  }
};

export const executeMultipleApiActions = async ({ actions = [], setLoading, dispatch }) => {
  try {
    setLoading?.(true);

    await Promise.all(
      actions.map(async ({ action, onSuccess }) => {
        try {
          const result = await action();
          onSuccess?.(result);
        } catch (error) {
          dispatch?.(notify(error.message, 'error'));
        }
      })
    );
    setLoading?.(false);
  } catch {
    setLoading?.(false);
  }
};
